// src/components/admin/nornsweave/modals/AddCalendarEventModal.js
import React from 'react';

function AddCalendarEventModal({ event, setEvent, onClose, onAdd, showNotification, settingsForm, setSettingsForm }) {
  const handleAdd = () => {
    if (!event.date) {
      showNotification('Please select a date', 'error');
      return;
    }
    const newEvent = {
      id: Date.now().toString(),
      ...event
    };
    setSettingsForm({
      ...settingsForm,
      academicCalendar: [...settingsForm.academicCalendar, newEvent]
    });
    onClose();
    setEvent({ date: '', type: 'closed', description: '' });
    showNotification('Calendar date added', 'success');
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        <h3 className="text-2xl font-bold text-slate-800 mb-4">Add Calendar Date</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Date</label>
            <input
              type="date"
              required
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={event.date}
              onChange={(e) => setEvent({...event, date: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Type</label>
            <select
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={event.type}
              onChange={(e) => setEvent({...event, type: e.target.value})}
            >
              <option value="closed">School Closed</option>
              <option value="halfday">Half Day</option>
              <option value="inservice">Inservice / No Students</option>
            </select>
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Description (optional)</label>
            <input
              type="text"
              placeholder="e.g., MLK Day, Parent Conferences"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              value={event.description}
              onChange={(e) => setEvent({...event, description: e.target.value})}
            />
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => {
                onClose();
                setEvent({ date: '', type: 'closed', description: '' });
              }}
              className="flex-1 bg-slate-200 text-slate-700 py-2 rounded-lg hover:bg-slate-300"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleAdd}
              className="flex-1 bg-rose-600 text-white py-2 rounded-lg hover:bg-rose-700"
            >
              Add Date
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCalendarEventModal;
